import Iconify from "minimals-template/components/Iconify"
import FacilitiesLogo from "routes/@assets/Icon - Facilities-iQ.svg?react"

const CUSTOM_ICONS = {
    FACILITIES_IQ: FacilitiesLogo,
}

export function ApplicationIcon({ appId, icon, width = 16, height = 16, ...props }) {
    const CustomIcon = CUSTOM_ICONS[appId]
    if (CustomIcon) {
        return <CustomIcon width={width} height={height} {...props} />
    }
    return <Iconify icon={icon} width={`${width}px`} height={`${height}px`} {...props} />
}
